import { render, staticRenderFns } from "./FileIndexer.vue?vue&type=template&id=4c229f23&scoped=true"
import script from "./FileIndexer.vue?vue&type=script&lang=js"
export * from "./FileIndexer.vue?vue&type=script&lang=js"
import style0 from "./FileIndexer.vue?vue&type=style&index=0&id=4c229f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c229f23",
  null
  
)

export default component.exports